import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { BoxWrapper, Modal, Button } from 'components/Base';
import { reduxForm, Field, Form, InjectedFormProps } from 'redux-form';
import Fields from 'components/Fields';
import api from 'api';
import { Notify } from 'utils';
import { linkColor } from 'utils/colors';
import { compose } from 'ramda';

interface SupportModalProps {
  isModalOpen: boolean;
  closeModal: Function;
}

const useStyles = makeStyles(() =>
  createStyles({
    modal: {
      width: '500px',
      padding: '1rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    },
    row: {
      display: 'flex',
      alignItems: 'baseline'
    },
    label: {
      width: '50%'
    },
    value: {
      fontWeight: 600
    },
    link: {
      textDecoration: 'none',
      color: linkColor,
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    }
  })
);

const SupportModal = ({
  isModalOpen,
  closeModal,
  handleSubmit,
  reset
}: SupportModalProps & InjectedFormProps) => {
  const classes = useStyles();

  const onSubmit = (values: any) => {
    api
      .reportIssue(values.message)
      .then(() => {
        closeModal();
        reset();
        Notify.success('Report Issue', `Your issue was sent successfully`);
      })
      .catch(() => {
        Notify.error('Unknown error', 'Please contact the administrator');
      });
  };

  return (
    <Modal isOpen={isModalOpen} closeModalFunc={() => closeModal()}>
      <BoxWrapper title="Need Support" closeModal={() => closeModal()}>
        <div className={classes.modal}>
          <div className={classes.row}>
            <div className={classes.label}>Email</div>
            <div className={classes.value}>
              <a
                href="mailto:support@fintegrate.co.uk"
                className={classes.link}
              >
                support@fintegrate.co.uk
              </a>
            </div>
          </div>
          <div className={classes.row}>
            <div className={classes.label}>Office opening hours</div>
            <div className={classes.value}>Monday to Friday 09:00 - 17:00</div>
          </div>

          <Form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
            <Field
              name="message"
              shrink
              fullWidth
              component={Fields.Text}
              multiline
              minRows={10}
              label="Report an Issue"
              validate={[Fields.Validators.required]}
            />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button
                type="button"
                color="primary"
                onClick={() => closeModal()}
              >
                Cancel
              </Button>
              <Button type="submit">Send</Button>
            </div>
          </Form>
        </div>
      </BoxWrapper>
    </Modal>
  );
};

export default compose(
  reduxForm({
    form: 'reportIssue',
    enableReinitialize: true
  })
)(SupportModal);
